import { Component, OnInit } from '@angular/core';

import { BasicNotificationElementComponent } from '../basic-notification-element/basic-notification-element.component';

@Component({
    selector: 'ridango-basic-error-notification',
    templateUrl: './basic-error-notification.component.html',
    styleUrls: ['./basic-error-notification.component.scss'],
})
export class BasicErrorNotificationComponent extends BasicNotificationElementComponent implements OnInit {
    constructor() {
        super();
    }

    ngOnInit() {
        this.title = this.notification.title ? this.notification.title : 'error';
        this.message = this.notification.message;
    }
}
